import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { loadIconManifest } from '@campus/svg';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Kick off the remote icon manifest load (non-blocking); <dcr-icon>s re-resolve when it lands.
loadIconManifest(environment.assets?.icons?.manifest);
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
